import { BundleResourcesPackage } from "resource-system";
import { Font } from "three/examples/jsm/loaders/FontLoader.js";
export class FontResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("FontResourcesPackage");
    }
    public get assets_fonts_DelaGothicOne_Regular_fontjson(): Font {
        return this.resource<Font>("assets/fonts/DelaGothicOne-Regular.fontjson");
    }
    public get assets_fonts_DelaGothicOne_Regular_ttf(): FontFace {
        return this.resource<FontFace>("assets/fonts/DelaGothicOne-Regular.ttf");
    }
}

